import { render } from "./ManageBilling.vue?vue&type=template&id=b7d87caa&scoped=true"
import script from "./ManageBilling.vue?vue&type=script&lang=js"
export * from "./ManageBilling.vue?vue&type=script&lang=js"

import "./ManageBilling.vue?vue&type=style&index=0&id=b7d87caa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d87caa"]])

export default __exports__